import Icon from '../../../../common/icons/Icon.js'
import {getState, useSelector} from '../../../../store.js'
import {
  Count,
  Plural,
  PluralBlock,
} from '../../../../common/components/Plural.js'
import POFilter from '../../../../common/components/POFilter.js'
import ButtonLink from '../../../../common/components/Button/ButtonLink.js'
import ButtonPrimary from '../../../../common/components/Button/ButtonPrimary.js'
import ButtonSecondary from '../../../../common/components/Button/ButtonSecondary.js'
import {showConfirmMessageModal} from '../../../../common/components/Modal/ConfirmMessageModal.js'
import TextArea from '../../../../common/components/TextArea.js'
import {splitStr} from '../../../../common/string.js'

const formName = 'FILTER_PANEL__PO_ID'

async function showParseBulkPOIDListModal({
  modalFormSelector,
  updateModalForm,
}) {
  await showConfirmMessageModal({
    title: 'Add PO IDs in Bulk',
    Message({form, updateModalForm}) {
      return (
        <div className="margin-top-10 margin-bottom-20">
          <p className="fs-00 lh-md margin-bottom-20">
            Enter PO IDs separated by spaces, line breaks, commas or tabs. Put
            quotes around IDs if they contain spaces, line breaks, commas or
            tabs {`(example: "PO 123" )`}.
          </p>

          <div className="w-75">
            <TextArea
              label="List of PO IDs"
              id="po_id_str_list"
              value={form.confirmValue}
              onChange={(confirmValue) => updateModalForm({confirmValue})}
              autoFocus
            />
          </div>
        </div>
      )
    },
    modalSize: 'sm',
    confirmText: 'Add PO IDs',
    cancelText: 'Cancel',
    confirmValue: '',
    async onResolve({outcome}) {
      if (!outcome) {
        return
      }

      const {po_id: existingPOIDs} = modalFormSelector(getState())
      const newPOIDs = splitStr(outcome)

      updateModalForm({
        po_id: [...new Set([...existingPOIDs, ...newPOIDs])],
      })
    },
  })
}

export default function POIDFilterPanel({modalFormSelector, updateModalForm}) {
  const modalForm = useSelector(modalFormSelector)
  const poIDs = modalForm.po_id
  const totalSelected = poIDs.length

  return (
    <div className="wrap--modal-filters wrap--modal-filters-po_ids">
      <div className="wrap__modal-subheader margin-bottom-25 flex--justify">
        <div>
          <div className="flex">
            <h4 className="fs-01 lh-sm uppercase margin-top-0 margin-bottom-0 flex--justify-col margin-right-10">
              <span>
                <strong>
                  PO ID<span className="lowercase">s</span>
                </strong>
                {totalSelected > 0 && (
                  <PluralBlock count={totalSelected}>
                    <span className="text--blue margin-left-5">
                      (<Count /> PO
                      <span className="lowercase">
                        <Plural p="s" /> added
                      </span>
                      )
                    </span>
                  </PluralBlock>
                )}
              </span>
            </h4>
          </div>
          {totalSelected > 0 && (
            <div className="margin-top-7">
              <ButtonPrimary
                isOutlined
                size="x-sm"
                className="margin-right-5"
                onClick={() =>
                  showParseBulkPOIDListModal({
                    modalFormSelector,
                    updateModalForm,
                  })
                }
              >
                Add a List of PO IDs
              </ButtonPrimary>
              <ButtonSecondary
                size="x-sm"
                onClick={() => updateModalForm({po_id: []})}
              >
                Clear All
              </ButtonSecondary>
            </div>
          )}
        </div>

        <div className="wrap--filter-search outer-wrap--product-search-100 w-35">
          <label
            className="label--input-prefix label--search"
            htmlFor="filters_tag_search"
          >
            <Icon name="search" className="icon--input-prefix" />
            <POFilter
              dropdown={`${formName}_PO_SEARCH`}
              excludedPOIDs={poIDs}
              onSelect={(po) => {
                updateModalForm({
                  po_id: [...new Set([...poIDs, po.po_id])],
                })
              }}
            />
          </label>
        </div>
      </div>
      {totalSelected > 0 ? (
        <ul className="list list--no-style list--modal-filters flex flex-wrap">
          {poIDs.map((poID, index) => {
            return (
              <li
                key={index}
                className="list__item list__item--modal-filters list__item--modal-filters-sku"
              >
                <span className="fs-00 lh-md margin-right-5">{poID}</span>
                <ButtonLink
                  onClick={() =>
                    updateModalForm({
                      po_id: poIDs.filter((on) => on !== poID),
                    })
                  }
                >
                  <Icon name="times" />
                </ButtonLink>
              </li>
            )
          })}
        </ul>
      ) : (
        <div className="list__item--modal-filters-no-results padding-top-15">
          <p className="fs-01 lh-md margin-bottom-20">
            Filter down to specific POs using the search bar.
          </p>
          <ButtonPrimary
            isOutlined
            size="sm"
            onClick={() =>
              showParseBulkPOIDListModal({
                modalFormSelector,
                updateModalForm,
              })
            }
          >
            Or Add a List of PO IDs
          </ButtonPrimary>
        </div>
      )}
    </div>
  )
}
